import { render } from "./CustomFileUpload.vue?vue&type=template&id=0241c76a"
import script from "./CustomFileUpload.vue?vue&type=script&lang=js"
export * from "./CustomFileUpload.vue?vue&type=script&lang=js"

import "./CustomFileUpload.vue?vue&type=style&index=0&id=0241c76a&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__